import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import _words from 'lodash/words';

import ButtonDisclosures from '../../../atoms/button-disclosures';
import ButtonSwitch from '../../../atoms/button-switch';
import CardModule from '../../shared/card-module';
import ColoredMap from '../../../../assets/images/ColoredMap.svg';
import GreyMap from '../../../../assets/images/GreyMap.svg';
import PropTypes from 'prop-types';
import TableBasic from '../../../atoms/table-basic';
import format from '../../../../utils/format';
import styles from './geographic-distribution.module.scss';
import useGeographicDistribution from '../../../../stores/profile/modules/use-geographic-distribution';
import { augmentClassName } from '../../../../utils/GlobalCssProxy';

const className = augmentClassName(styles);

const GeographicDistribution = ({
  hideSwitchAndMap = false,
  isFundNonProp = false,
  setRenderGeographicDistribution
}) => {
  const {
    asOfDate,
    geographies,
    geographySelected,
    hideForATA,
    onChangeGeography,
    regionSelected,
    renderDots,
    renderGeographicDistribution,
    showMap,
    showToggle,
    tableData,
    tableDataLabel,
    ticker
  } = useGeographicDistribution();

  const geoMap = regionSelected ? (
    <ColoredMap role="img" aria-label="colored map" />
  ) : (
    <GreyMap role="img" aria-label="grey map" />
  );
  const dotColorByRegion = region => {
    return _words(region.toLowerCase())[0];
  };
  setRenderGeographicDistribution && setRenderGeographicDistribution(renderGeographicDistribution);

  return (
    <CardModule
      data-analytics-componenttype="interactive-graphic-component"
      data-analytics-id="IG_GeographicDistribution"
      data-analytics-section="component"
    >
      <CardModule.Header>
        <Row>
          <Col>
            Geographic Distribution
            <CardModule.AsOfDateMedBlock>{format.date(asOfDate)}</CardModule.AsOfDateMedBlock>
          </Col>
          {hideSwitchAndMap ? undefined : (
            <Col md={6}>
              {showToggle && (
                <ButtonSwitch
                  options={geographies}
                  onChange={onChangeGeography}
                  selected={geographySelected}
                />
              )}
            </Col>
          )}
        </Row>
      </CardModule.Header>
      <CardModule.Body>
        <Row>
          {showMap && !hideSwitchAndMap && (
            <Col md={5} {...className('map-container', 'd-print-none')}>
              {geoMap}
            </Col>
          )}
          <Col>
            <TableBasic flush>
              <caption {...className('sr-only')}>
                Geographic distribution by {geographySelected.label} for {ticker}
              </caption>
              <thead>
                <tr>
                  <th scope="col" {...className('text-left')}>
                    {geographySelected.label}
                  </th>
                  <th scope="col" {...className('text-right')}>
                    {tableDataLabel}
                  </th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, index) => {
                  return (
                    <tr
                      data-key={`${row.country || ''}-${index}`}
                      key={`${row.country || ''}-${index}`}
                    >
                      <td>
                        {renderDots && row.region && !hideSwitchAndMap && (
                          <span
                            {...className('table-legend-dot', dotColorByRegion(row.region))}
                          ></span>
                        )}
                        {hideForATA ? '--' : format.text(row[geographySelected.value])}
                      </td>
                      <td {...className('text-right', 'font-weight-bold')}>
                        {row.allocationPercent === 0 || hideForATA
                          ? '--'
                          : format.percent(row.allocationPercent)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </TableBasic>
          </Col>
        </Row>
      </CardModule.Body>
      {!isFundNonProp && (
        <CardModule.Footer {...className('text-right')}>
          <ButtonDisclosures module={'geographic-distribution'} />
        </CardModule.Footer>
      )}
    </CardModule>
  );
};

GeographicDistribution.propTypes = {
  hideSwitchAndMap: PropTypes.bool,
  isFundNonProp: PropTypes.bool,
  setRenderGeographicDistribution: PropTypes.func
};

export default GeographicDistribution;
